import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { isActeNatureOperation, NatureOperationId } from '@lib/models/graphqlData';
import { FicheConseilState } from '@lib/models/generated/graphql';
import { AbstractPaginatedTableComponent } from 'finzzle-angular-utils';
export type FicheConseilTableItem = {
  id: string;
  conseilConfigId: string;
  natureOperationId: number | string; // Assuming natureOperation is a number or string
  natureOperationLabel: string;
  label: string;
  investisseurName: string;
  enveloppeName: string;
  produitName: string;
  montant: number;
  statut: FicheConseilState;
  dateModification: Date;
};
@Component({
  selector: 'app-fiche-conseil-table',
  templateUrl: './fiche-conseil-table.component.html',
  styleUrls: ['./fiche-conseil-table.component.scss'],
})
export class FicheConseilTableComponent extends AbstractPaginatedTableComponent<FicheConseilTableItem> {
  reloadFiches() {
    this.fetchData(true);
  }
  displayedColumns = [
    'label',
    'natureOperation',
    'investisseurName',
    'enveloppeName',
    'montant',
    'dateModification',
    'statut',
  ];
  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    this.fetchData(true);
  }

  onRowClick(row: FicheConseilTableItem) {
    if (row.natureOperationId === NatureOperationId.Souscription) {
      this.router.navigate(['fiche', row.id]);
    } else if (isActeNatureOperation(row.natureOperationId)) {
      this.router.navigate(['acte', row.id]);
    }
  }
}
